export default "__VITE_ASSET__BbPmslvd__"